import React from 'react';

function Wrapper({ message }) {
  return (
    <span>{message}</span>
  );
}

function ErrorBag({ target, errors }) {
  const raw = errors?.[target];
  const messages = Array.isArray(raw) ? raw : raw != null ? [raw] : [];

  return (
    <div className="error-bag">
      {messages.map((message, index) => {
        return (
          <div key={'error-wrapper-' + index} className="error-wrapper error">
            <Wrapper key={'error-' + index} message={message} />
          </div>
        );
      })}
    </div>
  );
}

export default ErrorBag;

